export function CardGroupIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667V7.5C2.5 8.42047 3.24619 9.16667 4.16667 9.16667H7.5C8.42047 9.16667 9.16667 8.42047 9.16667 7.5V4.16667C9.16667 3.24619 8.42047 2.5 7.5 2.5H4.16667ZM4.16667 4.16667H7.5V7.5H4.16667V4.16667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 2.5C11.5795 2.5 10.8333 3.24619 10.8333 4.16667V7.5C10.8333 8.42047 11.5795 9.16667 12.5 9.16667H15.8333C16.7538 9.16667 17.5 8.42047 17.5 7.5V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5H12.5ZM12.5 4.16667H15.8333V7.5H12.5V4.16667Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8333 12.5C10.8333 11.5795 11.5795 10.8333 12.5 10.8333H15.8333C16.7538 10.8333 17.5 11.5795 17.5 12.5V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H12.5C11.5795 17.5 10.8333 16.7538 10.8333 15.8333V12.5ZM15.8333 12.5H12.5V15.8333H15.8333V12.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16667 10.8333C3.24619 10.8333 2.5 11.5795 2.5 12.5V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H7.5C8.42047 17.5 9.16667 16.7538 9.16667 15.8333V12.5C9.16667 11.5795 8.42047 10.8333 7.5 10.8333H4.16667ZM4.16667 12.5H7.5V15.8333H4.16667V12.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
